import { Button, useNotify, useRedirect } from "react-admin";
import ModalComponent from "../../../../components/ModalComponent";
import React from "react";

const ConfirmDeleteUserModal = ({ open, onClose, userId, email }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const [loading, setLoading] = React.useState(false);
    const [response, setResponse] = React.useState("");

    const handleDeleteUser = async () => {
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${apiUrl}/users/${userId}/hard`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            const messageBack = await response.text();
            if (!response.ok) throw new Error(messageBack || 'Erro ao excluir usuário');
            let formattedMsg = messageBack;
            try {
                const parsed = JSON.parse(messageBack);
                if (parsed && Array.isArray(parsed.message)) {
                    formattedMsg = parsed.message;
                }
            } catch {}
            setResponse(formattedMsg);
        } catch (err) {
            let errorMsg = err.message;
            try {
                const parsed = JSON.parse(errorMsg);
                if (parsed && parsed.error) errorMsg = parsed.error;
            } catch {}
            notify(errorMsg, { type: "error" });
            handleCloseModal();
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        onClose();
        if (response) {
            redirect('/users');
        }
    };

    return (
        <ModalComponent
            open={open}
            onClose={handleCloseModal}
            title={
                    !response ? (
                    <span style={{ fontWeight: '600', color: '#D32F2F' }}>
                        Confirmar exclusão de usuário
                    </span>
                ) : (
                    <span style={{ fontWeight: '600' }}>
                        Usuário Excluído
                    </span>
                )}
            
            content={
                Array.isArray(response) ? (
                    <div>
                        <p><span style={{ fontWeight: 'bold' }}>UserId:</span> {userId}</p>
                        <p><span style={{ fontWeight: 'bold' }}>Email:</span> {email}</p>
                        <hr/>
                        <p style={{ fontWeight: 'bold' }}>Resultado da exclusão:</p>
                        <ul style={{ paddingLeft: 20 }}>
                            {response.map((item, idx) => (
                                <li key={idx} style={{ marginBottom: 8 }}>
                                    {item.status === 'success' ? (
                                        <span style={{ color: '#8BC34A' }}>
                                            <strong>{item.service}:</strong> {item.message}
                                        </span>
                                    ) : item.status === 'warning' ? (
                                        <span style={{ color: '#D39E00' }}>
                                            <strong>{item.service}:</strong> {item.message}
                                        </span>
                                    ) : item.status === 'error' ? (
                                        <span style={{ color: '#F44336' }}>
                                            <strong>{item.service}:</strong> {item.message}
                                        </span>
                                    ) : (
                                        <span>
                                            <strong>{item.service}:</strong> {item.message}
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : response ? (
                    <p>{response}</p>
                ) : (
                    <p>Esta ação é permanente e <strong>removerá o acesso do usuário ao RX PRO, além de apagar todos os seus dados do sistema.</strong> Deseja continuar?</p>
                )
            }
            actions={
                response ? (
                    <Button onClick={handleCloseModal} label="Fechar" />
                ) : (
                    <>
                        <Button onClick={onClose} label="Cancelar" disabled={loading} />
                        <Button onClick={handleDeleteUser} label="Excluir" variant="outlined" color="error" disabled={loading} />
                    </>
                )
            }
        />
    );
};

export default ConfirmDeleteUserModal;